import { Component, OnInit } from '@angular/core';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, LabTestAndProfile, UserDetail } from 'src/app/models';
import { CustomDatePipe } from 'src/app/pipes/custom-date.pipe';
import { LoaderService } from 'src/app/services/loader.service';
import { UserService } from 'src/app/services/user.service';
import { LabManagerService } from 'src/app/services/water-lab/lab-manager.service';

@Component({
  selector: 'bart-active-inactive-labs',
  templateUrl: './active-inactive-labs.component.html',
  styleUrls: ['./active-inactive-labs.component.scss'],
  providers: [CustomDatePipe]
})
export class ActiveInactiveLabsComponent implements OnInit {
  public userInfo: UserDetail;
  tableHeader: any;
  activeInactiveLabsData: LabTestAndProfile[] = []
  constructor(
    private _loaderService: LoaderService,
    private _labManagerService: LabManagerService,
    private _userService: UserService,
    private customDatePipe: CustomDatePipe,
  ) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.tableHeader = [
      { field: 'ActiveFlag', header: 'Active', display: 'table-cell', width: "4%",textalign: "center"},
      { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell', width: "20%" },
      { field: 'TestDescription', header: 'Description', display: 'table-cell', width: "35%" },
      { field: 'StartDate', header: 'Start Date', display: 'table-cell', width: "10%" },
      { field: 'EndDate', header: 'End Date', display: 'table-cell', width: "10%" },
    ];
    this.getActiveInactiveLabs();
  }

  getActiveInactiveLabs() {
    this._loaderService.show();
    let activeInactiveLabsParam = {
      "GETTESTSANDPROFILES": {
        "IncludeInactiveFlag": true
      }
    }
    this._labManagerService.getAllLabTestsAndProfiles(JSON.stringify(activeInactiveLabsParam)).subscribe(response => {
      if (response) {
        this.activeInactiveLabsData = response;

        this.activeInactiveLabsData.forEach(item => {
          item.StartDate = this.customDatePipe.transform(item.StartDate, "local", "MM/dd/yyyy");
          item.StartDateSort = new Date(this.customDatePipe.transform(item.StartDate, "local", "MM/dd/yyyy"));
          item.EndDate = this.customDatePipe.transform(item.EndDate, "local", "MM/dd/yyyy");
          item.EndDateSort = new Date(this.customDatePipe.transform(item.EndDate, "local", "MM/dd/yyyy"));
        });
      }
      this._loaderService.hide()

    },
      (error) => {
        this._loaderService.hide()
      });

    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: "Filter_Active_Inactive_Labs",
      value: '',
      eventDescription: UserActionDescription.ACTIVE_INACTIVE_LABS_GRID_LOADED
    });
    //#endregion

  }


  activeChange(event, rowData: any) {

    let isChecked = event.checked;
    this._loaderService.show();

    let updateLabTestAndProfileStatus = {
      "UPDATELABTESTANDPROFILESTATUS":
      {
        LabTestMasterID: rowData.LabTestMasterID,
        ActiveFlag: isChecked,
        IsProfile: rowData.IsProfile
      }
    }
    this._labManagerService.updateLabTestAndProfileStatus(JSON.stringify(updateLabTestAndProfileStatus)).subscribe(data => {
      this._loaderService.hide();

    }
      ,
      err => {
        this._loaderService.hide()
      });

    if (isChecked) {
      rowData.StartDate = this.customDatePipe.transform(new Date(), "local", "MM/dd/yyyy");
      rowData.EndDate = '';
    }
    else {
      rowData.EndDate = this.customDatePipe.transform(new Date(), "local", "MM/dd/yyyy");
    }

    
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: 'LabTestMasterID',
      value: rowData.LabTestMasterID,
      eventDescription: UserActionDescription.ACTIVE_INACTIVE_LABS_ACTIVE_CLICKED
    });
    //#endregion


  }
  sortColumn(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription: UserActionDescription.ACTIVE_INACTIVE_LABS_COLUMN_SORT
    });
    //#endregion
  }

  paginate(event) {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription: UserActionDescription.ACTIVE_INACTIVE_LABS_PAGE_NO_CLICKED
    });
    //#endregion
  }



}
